import { render, staticRenderFns } from "./Refs.vue?vue&type=template&id=2c7b1626&"
import script from "./Refs.vue?vue&type=script&lang=js&"
export * from "./Refs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports